import { userService } from "../_services";

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    me: {
      fullname: null,
      status: status.INITIAL
    }
  },

  getters: {
    fullname: ({ me }) => me && me.fullname,
    isMeLoaded: ({ me }) => me.status == status.LOADED, 
    hasRole: () => roles => userService.hasRole(roles), 
  },

  mutations: {
    setFullname: ({ me }, payload) => {
      me.fullname = payload
    },

    setMeStatus: ({ me }, status) => {
      me.status = status
    },
    
  },

}